import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/allWithDepartments`;

export const ROUTE: RouteDefinition = `${baseRoute}/allWithDepartments`;

export const URL = (): RouteDefinition => `${baseRoute}/allWithDepartments`;
